import apiClient from '@/lib/apiClient';

const BASE = '/admin/roles';

export interface AdminRoleRecord {
  id: number;
  key: string;
  name: string;
  description?: string | null;
  systemRole?: boolean;
  adminCount?: number;
  permissions: string[];
}

export const roleApi = {
  list: async (): Promise<AdminRoleRecord[]> => {
    const res = await apiClient.get(BASE);
    const data = res.data?.data ?? res.data;
    return Array.isArray(data) ? data : [];
  },
};
